import config from './config';

export const API_BASE_URL = config[process.env.NEXT_PUBLIC_ENVIRONMENT]?.apiBaseUrl;
export const NEW_API_URL = config[process.env.NEXT_PUBLIC_ENVIRONMENT]?.newApiUrl;
